import { APP_NAME } from '@hooks/useTitle'
import { reactErrorHandler } from '@sentry/react'
import { createRoot } from 'react-dom/client'

import App from './App'

const element = document.getElementById('app')

if (element === null) throw new Error('Could not find root element in HTML file')

document.title = `${APP_NAME} | Precision Planting`

const root = createRoot(element, {
  onCaughtError: reactErrorHandler(),
  onUncaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler()
})

root.render(<App />)
